/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-03-23 15:07:41
 * @modify date 2020-03-23 15:07:41
 * @desc [description]
 */
import axios from 'axios';

export async function getActivityTrackerData() {
  let data = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/count`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        data = response.data;
      }
    })
    .catch((err) => {
      console.log('launchpad activity tracker /count api error', err); // eslint-disable-line no-console
    });
  return data;
}

export async function expiryDate() {
  let services = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/admin/service/expiry/info`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        services = response.data.data;
      }
    })
    .catch((err) => {
      console.log('services/description java api error', err); // eslint-disable-line no-console
    });
  return services;
}

export async function emailAlreadyRegistered(accountId, email) {
  let services;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/account/email/${accountId}/${email}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        services = response.data.data;
      }
    })
    .catch((err) => {
      console.log('account email java api error', err); // eslint-disable-line no-console
    });
  return services;
}
